
import React from 'react'
import { Link } from 'react-router-dom'

interface Props {
  active: boolean
  disabled: boolean
  icon: string
  text: string
  path: string
}

const HeaderSubmenuItem = ({ active, disabled, icon, text, path }: Props) => {

  return (
    <li>
      {disabled ? (
        <span className={`submenu-span ${!active ? '' : 'active'}`}>
          <span className="submenu-icon">
            <div className="svg-icon-menu" style={{
              display: 'inline-block',
            }}>
              <div className="svg-icon-container">
                <span className={`${icon}${active ? '_full' : ''}`}></span>
              </div>
            </div>
          </span>
          <span className="d-none d-md-inline">{text}</span>
        </span>
      ) : (
        <Link className={`submenu-link ${!active ? '' : 'active'}`} to={path}>
          <span className="submenu-icon">
            <div className="svg-icon-menu" style={{
              display: 'inline-block',
            }}>
              <div className="svg-icon-container">
                <span className={`${icon}${active ? '_full' : ''}`}></span>
              </div>
            </div>
          </span>
          <span className="d-none d-md-inline">{text}</span>
        </Link>
      )}
    </li>
  )
}

export default HeaderSubmenuItem
